const prices = {
  table: {
    service: "Услуга",
    priceBgn: "Цена (лв.)",
    priceEur: "Цена (€)",
    missing: "—",
  },
  hero: {
    title: "Ценоразпис",
    description:
      "Актуални ориентировъчни цени в лева и евро. За персонализиран план и точна оферта, свържете се с нас.",
  },
  section: {
    title: "Цени по услуги",
    description:
      "Ако имате въпроси или искате да запишете час, използвайте формата за контакт.",
  },
  cards: [
    {
      title: "Корони",
      rows: [
        { name: "1 бр. MK корона", bgn: "430 лв.", eur: "€219.86" },
        { name: "1 бр. ZR корона", bgn: "800 лв.", eur: "€409.04" },
        {
          name: "1 бр. удължаване клинична корона",
          bgn: "500 лв.",
          eur: "€255.65",
        },
        {
          name: "1 бр. временна корона/лабораторна",
          bgn: "40 лв.",
          eur: "€20.45",
        },
      ],
    },
    {
      title: "All-on-4",
      sections: [
        {
          title: "Дентален композит",
          rows: [
            { name: "1 челюст", bgn: "4,500 лв.", eur: "€2,300.85" },
            { name: "2 челюсти", bgn: "9,000 лв.", eur: "€4,601.70" },
          ],
        },
        {
          title: "Метало-керамика",
          rows: [
            { name: "1 челюст", bgn: "6,000 лв.", eur: "€3,067.80" },
            { name: "2 челюсти", bgn: "12,000 лв.", eur: "€6,135.60" },
          ],
        },
      ],
    },
    {
      title: "All-on-6",
      sections: [
        {
          title: "Метало-керамика",
          rows: [
            { name: "1 челюст", bgn: "8,000 лв.", eur: "€4,090.40" },
            { name: "2 челюсти", bgn: "16,000 лв.", eur: "€8,180.80" },
          ],
        },
        {
          title: "Циркон",
          rows: [
            { name: "1 челюст", bgn: "9,500 лв.", eur: "€4,857.35" },
            { name: "2 челюсти", bgn: "19,000 лв.", eur: "€9,714.69" },
          ],
        },
      ],
    },
    {
      title: "Протетика",
      rows: [
        { name: "пластмасова акрил", bgn: "650 лв.", eur: "€332.34" },
        { name: "силиконова", bgn: "900 лв.", eur: "€460.17" },
        { name: "частична акрил", bgn: "450 лв.", eur: "€230.08" },
      ],
    },
    {
      title: "Почистване на зъбен камък",
      rows: [
        { name: "Почистване на зъбен камък", bgn: "170 лв.", eur: "€86.92" },
      ],
    },
    {
      title: "Обтурация",
      rows: [
        { name: "1 пов.", bgn: "120 лв.", eur: "€61.36" },
        { name: "2 пов.", bgn: "150 лв.", eur: "€76.69" },
        { name: "3 пов.", bgn: "180 лв.", eur: "€92.03" },
        { name: "след ендодонтия", note: "спрямо пов." },
      ],
    },
    {
      title: "Щифтово изграждане",
      rows: [
        { name: "Метал", bgn: "150 лв.", eur: "€76.69" },
        { name: "Циркон", bgn: "250 лв.", eur: "€127.82" },
      ],
    },
    {
      title: "Екстракция",
      rows: [
        { name: "1 корен", bgn: "150 лв.", eur: "€76.69" },
        { name: "много корени", bgn: "200 лв.", eur: "€102.26" },
        { name: "мъдрец", bgn: "300 лв.", eur: "€153.39" },
        { name: "ретиниран мъдрец", bgn: "400 лв.", eur: "€204.52" },
      ],
    },
    {
      title: "Избелване",
      rows: [
        { name: "кабинетно", bgn: "500 лв.", eur: "€255.65" },
        { name: "домашно", bgn: "400 лв.", eur: "€204.52" },
      ],
    },
    {
      title: "Естетика",
      rows: [
        { name: "фасети e-max", bgn: "700 лв.", eur: "€357.91" },
        { name: "бондинг/1 бр. зъб", bgn: "300 лв.", eur: "€153.39" },
      ],
    },
    {
      title: "Рентген",
      rows: [{ name: "x-ray panoramic", bgn: "35 лв.", eur: "€17.90" }],
    },
    {
      title: "Кост",
      rows: [{ name: "кост 1 кв.", bgn: "2,000 лв.", eur: "€1,022.60" }],
    },
  ],
};

export default prices;

